<template>
<unbreakable-part>
    <unbreakable>
        <slot></slot>
    </unbreakable>
    <span v-if="shown">
        <icon key="shown" size="s">keyboard_arrow_up</icon>
    </span>
    <span v-else>
        <icon key="hidden" size="s">keyboard_arrow_down</icon>
    </span>
</unbreakable-part>
</template>

<script>
import Vue from 'vue'
import { getParentToggleStore } from './toggle'

export default {
    props: {
        name: {},
    },
    data () {
        return {
            store: null,
            eName: this.name || null,
        }
    },
    mounted () {
        let parent = getParentToggleStore(this.$parent)
        this.store = parent.store
        this.eName = this.eName || parent.defaultName
        Vue.set(this.store, this.eName, !!this.store[this.eName])
    },
    computed: {
        shown () {
            return this.store && this.eName ? this.store[this.eName] : false
        },
    },
    components: {
        icon: require('./icon.vue').default,
        unbreakable: require('./unbreakable.vue').default,
        'unbreakable-part': require('./unbreakable-part.vue').default,

    },
}
</script>
